import { render, staticRenderFns } from "./VerificationTemplate.vue?vue&type=template&id=9c9b04aa&"
import script from "./VerificationTemplate.vue?vue&type=script&lang=js&"
export * from "./VerificationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports